import { motion } from 'framer-motion';
import { Sparkles, Store, Apple } from 'lucide-react';

const CTASection = () => {
  return (
    <section id="download" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#2d1b4e] via-[#1a0a2e] to-[#0a0a0b]" />
      
      {/* Animated Gradient Orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#ff84e4]/20 rounded-full blur-3xl"
          animate={{ 
            x: [0, 50, 0], 
            y: [0, -30, 0],
            scale: [1, 1.1, 1] 
          }}
          transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        />
        <motion.div
          className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#d987ff]/20 rounded-full blur-3xl"
          animate={{ 
            x: [0, -50, 0], 
            y: [0, 30, 0],
            scale: [1, 1.2, 1] 
          }}
          transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 backdrop-blur-sm border border-white/10 rounded-full mb-8"
          >
            <Sparkles size={16} className="text-[#ff84e4]" />
            <span className="font-mono text-xs uppercase tracking-wider text-white/80">
              Start Your Adventure Today
            </span>
          </motion.div>

          {/* Heading */}
          <h2 className="font-display text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Explore the City&apos;s Vibrant
            <br />
            <span className="text-[#ff84e4]">Nightlife Scene</span>
            <br />
            Like Never Before!
          </h2>

          <p className="text-xl text-white/60 max-w-2xl mx-auto mb-12">
            Download XtraGlass now and discover the best parties, venues, and experiences in your city
          </p>

          {/* Download Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <motion.a
              href="https://play.google.com/store/apps/details?id=com.pantech.xtraglass"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 px-10 py-5 bg-[#ff84e4] text-black font-mono text-sm uppercase tracking-wider rounded-full hover:shadow-[0_0_40px_rgba(255,132,228,0.5)] transition-all"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              Download on Google Play
            </motion.a>

            <motion.button
              className="flex items-center justify-center gap-3 px-10 py-5 bg-white/5 backdrop-blur-sm border border-white/20 text-white font-mono text-sm uppercase tracking-wider rounded-full hover:bg-white/10 transition-all cursor-not-allowed opacity-70"
              disabled
            >
              <Apple size={22} />
              iOS Coming Soon
            </motion.button>
          </div>

          {/* Restaurant CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="pt-8 border-t border-white/10"
          >
            <p className="text-white/50 mb-4">Are you a venue owner?</p>
            <motion.a
              href="https://docs.google.com/forms/d/1ffVvrxRdb14AfTiFOGuvkv6ll9d4e_u2xU0dTFMeVgM/viewform?edit_requested=true"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-[#ffe03d] text-black font-mono text-sm uppercase tracking-wider rounded-full hover:shadow-[0_0_30px_rgba(255,224,61,0.4)] transition-all"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Store size={18} />
              Claim Your Restaurant Page
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;